import React, { memo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import FileInformation from '../../FileExplorer/FileInformation';

const FileInformationsModal = ({ show, onClose, element }) => {
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>File informations</Modal.Header>
            <Modal.Body>
                <FileInformation
                    fileElement={{
                        ...element.file,
                        createdBy: element.file.updatedBy,
                    }}
                    fallback={() => <p>No information available</p>}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default memo(FileInformationsModal);
